import * as types from '../actions/actionTypes';

const initialState = {
  receiptUrl: "",
  receiptSignature: "", // pngBase64
};

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_RECEIPT_URL:
    case types.SET_RECEIPT_SIGNATURE:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
